<template>
  <div :class="classModifiers">
    <div :class="iconClassModifiers"></div>
    <div class="market-disabled-outcome-v2__text">
      {{ buttonText }}
    </div>
  </div>
</template>

<script src="./market-disabled-outcome-v2.js"></script>
<style src="./market-disabled-outcome-v2.scss" lang="scss"></style>
